"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var Hubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _ChecklistItem = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ChecklistItem"));

var FeatureName = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuiteCatalogTableCell__FeatureName",
  componentId: "sc-1pkv6nx-0"
})(["padding:10px 0;display:inline-block;& > p{margin-left:8px;margin-bottom:0;font-weight:500;display:inline-block;}text-align:left;"]);

var GrowthSuiteCatalogTableCell = function GrowthSuiteCatalogTableCell(_ref) {
  var merchandiseId = _ref.merchandiseId,
      featureId = _ref.featureId,
      hub = _ref.hub;
  var feature = _ImmutableMerchandiseIdMap.default[merchandiseId].features[featureId];
  var shortLimitContent = feature && feature.shortLimitKey ? _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "pricing-pages.shortLimits." + feature.shortLimitKey
  })) : null;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("td", null), _react.default.createElement("td", {
    style: {
      width: '27%'
    }
  }, _react.default.createElement(FeatureName, null, featureId && _react.default.createElement(_ChecklistItem.default, {
    tooltipMessage: (0, _getFeatureDescriptionKey.default)(featureId, hub),
    message: "pricing-pages.features." + featureId + ".name"
  }))), _react.default.createElement("td", {
    style: {
      width: '20%'
    }
  }, shortLimitContent));
};

GrowthSuiteCatalogTableCell.propTypes = {
  featureId: _propTypes.default.string,
  merchandiseId: _propTypes.default.number.isRequired,
  hub: _propTypes.default.oneOf(Object.keys(Hubs).map(function (hubKey) {
    return Hubs[hubKey];
  })).isRequired
};
var _default = GrowthSuiteCatalogTableCell;
exports.default = _default;
module.exports = exports.default;